import { ArticleFromDom } from '../../Integrations/ProductActionsIntegrations/Types';

export interface ShopwareCartWithMessages extends ShopwareCart {
    cartMessages: string[];
}
export interface ShopwareCart {
    mode: 'shopware';
    carts: CustomerCarts | null;
    // visibility flag for slide-in cart
    visible: boolean;
}

export interface LocalCart {
    mode: 'local';
    items: CartItemType[];
    // visibility flag for slide-in cart
    visible: boolean;
}

export interface CartContextInterface {
    cart: ShopwareCartWithMessages | LocalCart;
    updateCartItems: (updateItem: CartItemType, action: ActionType, customerId?: string) => void;
    setCartVisibility: (visibility: boolean) => void;
    activeItems: CartItemType[];
    latestAction: ActionType | null;
    syncFailure: boolean;
    deleteCart: () => void;
    totalItemsInCarts: number;
    refreshCart: (visibilityOverride?: boolean) => void;
}

export interface CustomerCarts {
    [customerId: string]: {
        [items: string]: CartItemType[];
    };
}

export type ProductType = 'product' | 'voucher' | 'gift' | 'voucherWithDynamicPrice';

export interface CartItemType extends ArticleFromDom {
    quantity: number;
    type: ProductType;
    // TODO: outsource this to separate type? Might require a lot of refactoring
    voucher_design_name?: string;
}

export enum ActionType {
    Add,
    Remove,
    Update,
}
export interface CartPayload {
    data: {
        items: Array<CartItemPayload | VoucherWithDynamicPriceCartPayloadItem | VoucherCartPayloadItem>;
        consultantId: string | null;
    };
}

export interface CartItemPayload {
    articleNumber: string;
    quantity: number;
    profileLabel: string | null;
    type: ProductType;
}

export interface VoucherWithDynamicPriceCartPayloadItem {
    articleNumber: string;
    quantity: number;
    profileLabel: string | null;
    voucher_custom_value: string;
    voucher_design_name: string;
    priceInCents: number;
    type: 'voucherWithDynamicPrice';
}

export interface VoucherCartPayloadItem {
    articleNumber: string;
    quantity: number;
    profileLabel: string | null;
    voucher_design_name: string;
    type: 'voucher';
}

export interface AugmentedCartItemPayload extends CartItemType {
    profileLabel: string | null;
}

export interface CartProfilePayload {
    label: string;
    items: CartItemPayload[];
}
